__turbopack_context__.v({
  "cancelChangesModal": "cancelChangesModal-module-scss-module__-YeBMG__cancelChangesModal",
  "discardButton": "cancelChangesModal-module-scss-module__-YeBMG__discardButton",
  "modalBody": "cancelChangesModal-module-scss-module__-YeBMG__modalBody",
});
